import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	maxIssues: {
		id: 'software-deployments.timeline.issue-title.max-pagination-warning.max-issues',
		defaultMessage:
			'Displaying maximum number of issues. Please add some filters to refine your search.',
		description: 'Max issues warning',
	},
	maxDeployments: {
		id: 'software-deployments.timeline.issue-title.max-pagination-warning.max-deployments',
		defaultMessage:
			'Cannot display all deployments for these issues. Please add some filters to refine your search.',
		description: 'Max deployments warning',
	},
	warning: {
		id: 'software-deployments.timeline.issue-title.max-pagination-warning.warning',
		defaultMessage: 'Warning',
		description: '',
	},
});
